import { Options, Vue } from 'vue-class-component';
import Toggle from '@vueform/toggle';

import * as EconomicSectorService from '@/services/economic-sector.service';
import { IEconomicSector } from '@/domain/economic-sector.model';

@Options({
  name: 'economic-sector-edit',
  props: {
    id: String,
  },
  components: {
    Toggle,
  },
})
export default class EconomicSectorEdit extends Vue {
  public id: string;
  public errorMessage = '';
  public errors: any = {};
  public hasError = false;
  public row: IEconomicSector = {
    description: '',
    enabled: false,
  };

  public mounted(): void {
    EconomicSectorService.get(this.id)
      .then((res: IEconomicSector) => {
        if (res && res.id) {
          this.row = res;
        } else {
          this.errorMessage = 'Registro não encontrado.';
        }
      })
      .catch(() => {
        this.errorMessage = 'Registro não encontrado.';
      });
  }

  public goBack() {
    this.$router.push('/economic-sector');
  }

  public validation() {
    this.errors = {};
    this.hasError = false;

    if (!this.row.description) {
      this.errors.description = 'Este campo deve ser preenchido.';
      this.hasError = true;
    }

    return !this.hasError;
  }

  public save() {
    if (this.validation()) {
      EconomicSectorService.update({
        id: parseInt(this.id),
        description: this.row.description,
        enabled: this.row.enabled,
      })
        .then(() => {
          this.$router.push('/economic-sector');
        })
        .catch(() => {
          this.errorMessage = 'Ocorreu um erro ao gravar o registro.';
        });
    }
  }
}
